'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

export default function NotFound() {
  const router = useRouter();

  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <h1
            className="text-9xl font-black"
            style={{ color: 'rgba(0,174,239,0.15)' }}
          >
            404
          </h1>
        </div>

        <h2 className="text-2xl font-extrabold text-foreground mb-3">Page Not Found</h2>
        <p className="text-slate-500 mb-8">
          The page you&apos;re looking for doesn&apos;t exist. Let&apos;s get you back!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={handleGoBack}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-gray-200 bg-white text-sm font-bold text-foreground hover:bg-gray-50 transition-colors"
          >
            Go Back
          </button>

          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 rounded-full h-12 px-8 font-bold text-white text-sm transition-all hover:scale-[1.02]"
            style={{ backgroundColor: '#00aeef', boxShadow: '0 4px 16px 0 rgba(0,174,239,0.3)' }}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}